import React, { ReactNode, useMemo } from 'react';
import type { CreativeCredit } from 'sr-types/lib/shortlist/v1/graphql';
import { buildCreativeCreditRows, WorkEntriesDatagrid } from '../../../../workEntries';
import I18n from '../../../../i18n/I18n';
import { H } from '../../../../Layout';

type KeyCreditsReviewStepProps = {
    credits: CreativeCredit[];
    onBack: () => void;
    onSave: (selectedIds: string[], selectedCredits: CreativeCredit[]) => void;
    saveLoading?: boolean;
    footerAccessory?: ReactNode;
};

export default function KeyCreditsReviewStep({
    credits,
    onBack,
    onSave,
    saveLoading = false,
    footerAccessory
}: KeyCreditsReviewStepProps) {
    const rows = useMemo(() => buildCreativeCreditRows(credits), [credits]);

    return (
        <H
            sx={{
                flex: 1,
                minHeight: 0,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <WorkEntriesDatagrid
                rows={rows}
                enableSelection
                showKeyIcon={false}
                enableReorder
                enableSearch
                enableFilters
                minCardColumnWidth={200}
                footerFilterMode="selected"
                rowActionsEnabled={false}
                showBackButton
                onBack={onBack}
                onBulkAction={(selectedIds, selectedRows) =>
                    onSave(
                        selectedIds,
                        selectedRows.map((row) => row.source)
                    )
                }
                bulkActionLoading={saveLoading}
                bulkActionLabel={<I18n token="shortlist.line.item.key.credits.add.cta" />}
                footerAccessory={footerAccessory}
            />
        </H>
    );
}
